import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'
import Composition from '@src/components/composition/composition'
import { WorkoutExercise } from '@src/data/workout-exercise'
import { WorkoutService } from '@src/service/workout'

@Component({
  computed: {
    selectedExercises () {
      return this.$store.state.new_workout.workoutExercises
    }
  }
})
export class WorkoutComposition extends Vue {
  @Prop({ required: false, default: false })
  public showAssistant: boolean

  protected workoutService: WorkoutService = new WorkoutService()
  protected selectedExercises: WorkoutExercise[]

  render (h: CreateElement) {
    let windowWidth = window.innerWidth
    const progress = this.workoutService.buildWorkoutComposition(this.selectedExercises)
    return <Composition progress={progress}
                        muscleCircleDiameter={windowWidth > 800 ? 80 : 85}
                        movementCircleDiameter={windowWidth > 800 ? 80 : 85}
                        filterCallback={this.filterByTags} title={'PAGE.CONTENT.WORKOUT.WORKOUT_COMPOSITION'}
                        straigthMobileProgressBars={true}
                        showAssistant={this.showAssistant} />
  }

  filterByTags (selectedFilters: Set<string>) {
    this.$store.dispatch('filterExercises', { tags: selectedFilters })
  }
}
